"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.endOfPeriod = exports.firstOfPeriod = exports.diffDays = exports.diffBusinessDays = exports.addMonths = exports.addBusinessDays = exports.addDays = void 0;
const assert_1 = __importDefault(require("assert"));
const lodash_1 = __importDefault(require("lodash"));
const luxon_1 = require("luxon");
const consts_1 = __importDefault(require("../consts"));
const error_1 = require("../error");
const datestr_1 = require("./datestr");
const datetime_1 = __importStar(require("./datetime"));
/**
 * Currently this file contains all utilities methods related to date manupilation, more specifically related to Util.FullDateStr.
 * Util.FullDateStr is finley's standard date format (or more accurately, date portion of ISO standard).
 */
/**
 * Add days to Util.FullDateStr.  It allows substraction by negative num value.
 * @param val: input Util.FullDateStr
 * @param num: number of days to add
 * @returns Util.FullDateStr with days added
 */
const addDays = (val, numDays) => {
    (0, assert_1.default)(lodash_1.default.isInteger(numDays), 'num must be an integer value');
    const parsedDateTime = luxon_1.DateTime.fromISO(val);
    (0, assert_1.default)(parsedDateTime.isValid, `${parsedDateTime.invalidReason}: ${parsedDateTime.invalidExplanation}`);
    return (0, datestr_1.datetimeToFullDateStr)(parsedDateTime.plus({ days: numDays }));
};
exports.addDays = addDays;
/**
 * Add specified business days to Util.FullDateStr.  It allows subtraction by negative num values.
 * @param val: input Util.FullDateStr
 * @param num: number of business days to add
 * @returns Util.FullDateStr with business days added
 */
const addBusinessDays = (val, numBusinessDays, holidays = datetime_1.USFederalHolidays, observed = true) => {
    (0, assert_1.default)(lodash_1.default.isInteger(numBusinessDays), 'num must be an integer value');
    const parsedDateTime = luxon_1.DateTime.fromISO(val);
    (0, assert_1.default)(parsedDateTime.isValid, `${parsedDateTime.invalidReason}: ${parsedDateTime.invalidExplanation}`);
    return (0, datestr_1.datetimeToFullDateStr)((0, datetime_1.addBusinessDays)(parsedDateTime, numBusinessDays, holidays, observed));
};
exports.addBusinessDays = addBusinessDays;
/**
 * Add months to Util.FullDateStr. It allows substraction by negative num value. This should not be used to expect matching day values across end of month boundary days where not all months maintain the same values (leap year February, 30/31 day months).
 * @param val: input Util.FullDateStr
 * @param num: number of months to add
 * @returns Util.FullDateStr with days added
 */
const addMonths = (val, numMonths) => {
    (0, assert_1.default)(lodash_1.default.isInteger(numMonths), 'num must be an integer value');
    const parsedDateTime = luxon_1.DateTime.fromISO(val);
    (0, assert_1.default)(parsedDateTime.isValid, `${parsedDateTime.invalidReason}: ${parsedDateTime.invalidExplanation}`);
    return (0, datestr_1.datetimeToFullDateStr)(parsedDateTime.plus({ months: numMonths }));
};
exports.addMonths = addMonths;
/**
 * @param a: base input Util.FullDateStr
 * @param b: compare input Util.FullDateStr
 * @returns number of business days in between
 */
const diffBusinessDays = (a, b, holidays = datetime_1.USFederalHolidays) => {
    const aDateTime = luxon_1.DateTime.fromISO(a);
    (0, assert_1.default)(aDateTime.isValid, `${aDateTime.invalidReason}: ${aDateTime.invalidExplanation}`);
    const bDateTime = luxon_1.DateTime.fromISO(b);
    (0, assert_1.default)(bDateTime.isValid, `${bDateTime.invalidReason}: ${bDateTime.invalidExplanation}`);
    return (0, datetime_1.diffBusinessDays)(aDateTime, bDateTime, holidays);
};
exports.diffBusinessDays = diffBusinessDays;
/**
 * Calculate number of days between two Util.FullDateStr.
 * @param a: base Util.FullDateStr
 * @param b: comp Util.FullDateStr
 * @returns number of days difference from a (base Util.FullDateStr)
 */
const diffDays = (a, b) => {
    const aDateTime = luxon_1.DateTime.fromISO(a);
    (0, assert_1.default)(aDateTime.isValid, `${aDateTime.invalidReason}: ${aDateTime.invalidExplanation}`);
    const bDateTime = luxon_1.DateTime.fromISO(b);
    (0, assert_1.default)(bDateTime.isValid, `${bDateTime.invalidReason}: ${bDateTime.invalidExplanation}`);
    const diff = aDateTime.diff(bDateTime, ['days']);
    return diff.days;
};
exports.diffDays = diffDays;
/**
 * Return first of period given a Util.FullDateStr and period type.
 * @param val: input Util.FullDateStr
 * @param periodType: input string
 * @returns Util.FullDateStr but set to first of the month
 */
const firstOfPeriod = (val, periodType) => {
    const parsedDateTime = luxon_1.DateTime.fromISO(val);
    (0, assert_1.default)(parsedDateTime.isValid, `${parsedDateTime.invalidReason}: ${parsedDateTime.invalidExplanation}`);
    switch (periodType) {
        case 'day':
        case 'week':
        case 'month':
        case 'quarter':
        case 'year':
            return (0, datestr_1.datetimeToFullDateStr)(parsedDateTime.startOf(periodType));
        default:
            return (0, error_1.finleyAssertUnreachable)(periodType, `Encountered unsupported periodType for FirstOfPeriod util [periodType:${periodType}]`);
    }
};
exports.firstOfPeriod = firstOfPeriod;
/**
 * Return end of period given a Util.FullDateStr and period type.
 * @param val: input Util.FullDateStr
 * @param periodType: input string
 * @returns Util.FullDateStr but set to end of the period
 */
const endOfPeriod = (val, periodType) => {
    const parsedDateTime = luxon_1.DateTime.fromISO(val);
    (0, error_1.finleyAssert)(parsedDateTime.isValid, `EndOfPeriod util error [reason:${parsedDateTime.invalidReason}] [explanation:${parsedDateTime.invalidExplanation}]`);
    switch (periodType) {
        case 'day':
        case 'week':
        case 'month':
        case 'quarter':
        case 'year':
            return (0, datestr_1.datetimeToFullDateStr)(parsedDateTime.endOf(periodType));
        default:
            return (0, error_1.finleyAssertUnreachable)(periodType, `Encountered unsupported periodType for EndOfPeriod util [periodType:${periodType}]`);
    }
};
exports.endOfPeriod = endOfPeriod;
const lastCloseOfBusiness = () => {
    const currentDT = datetime_1.default.currentDateTime();
    const currentDate = (0, datestr_1.datetimeToFullDateStr)(currentDT);
    // if currentDate is not bizDay, will return last business day in the past
    const lastBusinessDate = (0, exports.addBusinessDays)(currentDate, 0);
    if (currentDate !== lastBusinessDate) {
        return lastBusinessDate;
    }
    if (currentDT.hour >= consts_1.default.closeOfBusinessHour) {
        return currentDate;
    }
    return (0, exports.addBusinessDays)(currentDate, -1);
};
exports.default = {
    addDays: exports.addDays,
    addBusinessDays: exports.addBusinessDays,
    addMonths: exports.addMonths,
    diffBusinessDays: exports.diffBusinessDays,
    diffDays: exports.diffDays,
    firstOfPeriod: exports.firstOfPeriod,
    endOfPeriod: exports.endOfPeriod,
    lastCloseOfBusiness,
};
//# sourceMappingURL=calc.js.map